import { toAPIDateString, fromAPIDateString, validateDateStringRange } from 'utils/DateHelper';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      // indicates an error with a price request
      opmMixin_fetchingError: false,
    };
  },
  i18nOptions: { namespaces: ['errors'] },
  computed: {
    ...mapGetters([
      'getActiveObjectData',
    ]),

    // start date from the object store
    opmMixin_objectStoreStartDate() {
      return this.$store.state.objects.priceRequestData.startDate;
    },
    // end date from the object store
    opmMixin_objectStoreEndDate() {
      return this.$store.state.objects.priceRequestData.endDate;
    },
    // persons from the object store
    opmMixin_objectStorePersons() {
      return this.$store.state.objects.priceRequestData.persons;
    },
    // viewed date from the object store
    opmMixin_objectViewedPickerDate() {
      return this.$store.state.objects.priceRequestData.viewedDate;
    },
    // checks for object vacancy of active object
    opmMixin_hasObjectVacancy() {
      return this.getActiveObjectData.availability.count > 0;
    },
    // v-model for persons select
    opmMixin_selectedPersons: {
      get() {
        return this.opmMixin_objectStorePersons;
      },
      set(value) {
        this.opmMixin_priceRequest({
          startDate: this.opmMixin_objectStoreStartDate,
          endDate: this.opmMixin_objectStoreEndDate,
          persons: value,
        });
      },
    },
    // v-model for the flatpickr
    // gets and sets the object store values
    opmMixin_fpModelValue: {
      get() {
        if (validateDateStringRange(this.opmMixin_objectStoreStartDate, this.opmMixin_objectStoreEndDate)) {
          return [fromAPIDateString(this.opmMixin_objectStoreStartDate), fromAPIDateString(this.opmMixin_objectStoreEndDate)];
        }
        return [];
      },
      set({ dateArr }) {
        if (this.$route.query.startDate !== toAPIDateString(dateArr[0])
            || this.$route.query.endDate !== toAPIDateString(dateArr[1])
            || parseInt(this.$route.query.persons, 10) !== this.opmMixin_objectStorePersons) {
          this.$router.push({
            ...this.$route,
            query: {
              ...this.$route.query,
              startDate: toAPIDateString(dateArr[0]) || undefined,
              endDate: toAPIDateString(dateArr[1]) || undefined,
              persons: this.opmMixin_objectStorePersons,
            },

          });
        }
        this.opmMixin_priceRequest({
          startDate: toAPIDateString(dateArr[0]) || null,
          endDate: toAPIDateString(dateArr[1]) || null,
          persons: this.opmMixin_objectStorePersons,
          language: this.$store.getters.getCurrentLanguage,
        });
      },
    },
    opmMixin_objectStoreParams() {
      const params = { persons: this.opmMixin_objectStorePersons };
      if (this.opmMixin_objectStoreStartDate !== null
        && this.opmMixin_objectStoreEndDate !== null) {
        params.startDate = this.opmMixin_objectStoreStartDate;
        params.endDate = this.opmMixin_objectStoreEndDate;
      }
      return params;
    },
  },
  methods: {
    // replace route with current params
    opmMixin_replaceRoute() {
      // only replace route if params actually changed to avoid navigation duplicate
      const { startDate: routeStartDate, endDate: routeEndDate, persons: routePersons } = this.$route.query;
      if (
        JSON.stringify([routeStartDate, routeEndDate, parseInt(routePersons, 10)])
          === JSON.stringify([this.opmMixin_objectStoreStartDate, this.opmMixin_objectStoreEndDate, this.opmMixin_objectStorePersons])
      ) return;

      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          startDate: this.opmMixin_objectStoreStartDate,
          endDate: this.opmMixin_objectStoreEndDate,
          persons: this.opmMixin_objectStorePersons,
        },
        params: this.$route.params,
        meta: this.$route.meta,
        hash: this.$route.hash,
      });
    },
    // requesting the API or just set store without proper vacancy data
    opmMixin_priceRequest({ startDate, endDate, persons }) {
      if (!this.opmMixin_hasObjectVacancy) {
        this.$store.commit('SET_OBJECT_PRICE_REQUEST_DATA', {
          startDate,
          endDate,
          persons,
          language: this.$store.getters.getCurrentLanguage,
        });
        this.$store.commit('SET_OBJECT_PRICE_IDENTIFIER_KEY');
        this.opmMixin_replaceRoute();
        return;
      }

      this.opmMixin_fetchingError = false;
      this.$store.dispatch('GET_OBJECT_PRICE_REQUEST_DATA', {
        startDate,
        endDate,
        persons,
        language: this.$store.getters.getCurrentLanguage,
      })
        .catch(() => {
          // reset data
          this.$store.dispatch('GET_OBJECT_PRICE_REQUEST_DATA', {
            startDate: null,
            endDate: null,
            persons: 2,
            language: this.$store.getters.getCurrentLanguage,
          }).catch(() => {});

          this.opmMixin_fetchingError = true;
          this.$bvToast.toast(this.$t('errors:object.priceApi.body'), {
            title: this.$t('errors:object.priceApi.header'),
            appendToast: true,
            variant: 'warning',
          });
        })
        .finally(() => {
          this.opmMixin_replaceRoute();
        });
    },
  },
};
